import axios from "@/axios";
import BasicAuthService from "./basicAuthService";

const basicAuth = new BasicAuthService(axios, localStorage);
export default basicAuth;
